import React, { Component, createRef } from 'react';
import { array, node, string, func } from 'prop-types';
import classnames from 'classnames/bind';

import ActionIcon from 'elements/ActionIcons/ActionIcon';

import styles from './Header.css';

const cx = classnames.bind(styles);

class Header extends Component {
  static propTypes = {
    className: string,
    children: node.isRequired,
    smallMenu: array,
    mainMenu: array,
    onToggleMenu: func,
    airtelHref: string
  }

  static defaultProps = {
    airtelHref: '/'
  }

  headerRef = createRef();
  scrollTop = 0;
  offset = 100;

  componentDidMount = () => {
    window.onscroll = this.handleScroll;
  }

  componentWillUnmount = () => {
    window.onscroll = null;
  }

  handleMainMenuCallback = (e) => {
    const { mainMenu } =  this.props;
    const targetId = e.currentTarget.dataset.id;
    const link = mainMenu[targetId];

    link.callback && e.preventDefault();
    link.callback && link.callback(link);
  }

  handleScroll = () => {
    const scrollY = window.scrollY;
    const headerClasses = this.headerRef.current.classList;

    if (Math.abs(scrollY - this.scrollTop) > this.offset) {
      
      if (scrollY - this.scrollTop > this.offset) {
        headerClasses.add(styles.hidden);
      } else {
        headerClasses.remove(styles.hidden);
      }

      this.scrollTop = scrollY;
    }
  }

  renderSmallMenu = () => {
    const { smallMenu, className } = this.props;

    return (
      <div className={classnames(styles.secondaryMenu, className)}>
        {smallMenu.map((link, i) => (
          <a
            className={styles.secondaryLink}
            href={link.href}
            key={`small-link-${i}`}
          >
            {link.name}
          </a>
        ))}
      </div>
    );
  }

  renderMainMenu = () => {
    const { mainMenu, onToggleMenu } =  this.props;

    return (
      <div className={styles.menu}>
        {mainMenu.map((link, i) => (
          <a
            className={styles.menuLink}
            href={link.href}
            key={`main-link-${i}`}
            data-id={i}
            onClick={this.handleMainMenuCallback}
          >
            {link.name}
          </a>
        ))}
        <ActionIcon
          customClasses={styles.toggleMenu}
          icon="menu"
          type="navigation"
          exception
          onClick={onToggleMenu}
        />
      </div>
    );
  }

  render () {
    const { airtelHref, children, className, smallMenu, mainMenu } = this.props;

    return (
      <header className={styles.header} ref={this.headerRef}>
        {smallMenu && this.renderSmallMenu()}
        <div className={classnames(styles.wrapper, className)}>
          <div className={styles.logoContainer}>
            <a href={airtelHref}>
              <div className={cx(styles.logo, { landing: smallMenu && mainMenu })} />
            </a>
          </div>

          {mainMenu && this.renderMainMenu()}

          <div className={styles.navBar}>
            {children}
          </div>
        </div>
      </header>
    );
  }
}

export default Header;


// WEBPACK FOOTER //
// ./src/uis/components/Header/Header.js